import React, { useState } from 'react';
import { CiEdit } from 'react-icons/ci';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { SystemGrid } from "library";

const Settings = () => {
    const [descEdit, setDescEdit] = useState(true);
    const [metaKeyword, setMetaKeyword] = useState(true);
    const [publicUrl, setPublicUrl] = useState(true);

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Manage Global Settings" tagLine="" />
                <div className="container-fluid mt-80 fieldsetGridAndForm">
                    <div className="row">
                        <div className="col-md-12">
                            <SystemGrid dataSource="Application/GlobalSettings">
                                <Column field="Name" title="Name" width="" />
                                <Column field="Value" title="Value" width="" />
                                <Column field="Description" title="Description" width="" />
                            </SystemGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
};

export default Settings;